import { ApolloLink } from "@apollo/client";

export const cookieRE = /^(?:.+; )?XSRF-TOKEN=([^;]+).*/;

export const withXCSRFToken = () => {
  return new ApolloLink((operation, forward) => {
    const matches = document.cookie.match(cookieRE);
    if (matches) {
      operation.setContext(({ headers = {} }) => ({
        headers: { ...headers, "X-CSRF-Token": matches[1] },
      }));
    }

    return forward(operation);
  });
};
